import session from 'frontend/shared/javascripts/util/session'
import { isNativeApp } from 'shared/javascripts/util/detection'
import { mobileBreakpoint } from 'shared/javascripts/util/mobile_breakpoint'
import type { HiddenField } from './form'

const TRAFFIC_SOURCE_KEY = 'survey:traffic-source'

export type Device = 'App' | 'Mobile' | 'Desktop'

export function currentDevice(): Device {
  if (isNativeApp()) return 'App'
  return mobileBreakpoint.matches ? 'Mobile' : 'Desktop'
}

export function classifyTrafficSource(search: string, referrer: string, ownHost: string): string {
  const utmSource = new URLSearchParams(search).get('utm_source')
  if (utmSource) return utmSource

  let host: string
  try {
    host = new URL(referrer).hostname
  } catch {
    return 'Direct'
  }
  if (host === ownHost) return 'Direct'
  // YouTube app's referrer is android-app://com.google.android.youtube, so must be checked before Google
  if (/youtube|youtu\.be/.test(host)) return 'YouTube'
  if (/google/.test(host)) return 'Google'
  return host.replace(/^www\./, '')
}

export function trafficSource(): string {
  try {
    const remembered = sessionStorage.getItem(TRAFFIC_SOURCE_KEY)
    if (remembered !== null) return remembered
  } catch {
    // sessionStorage unavailable: classify the current page instead
  }

  const source = classifyTrafficSource(location.search, document.referrer, location.hostname)
  try {
    sessionStorage.setItem(TRAFFIC_SOURCE_KEY, source)
  } catch {
    // Ignore storage errors (private mode, blocked storage, etc.)
  }
  return source
}

export function hiddenFieldValues(): Record<HiddenField, string> {
  return {
    userId: session.userId?.toString() ?? '',
    // Without the query string, which can carry tokens or email addresses.
    page: location.origin + location.pathname,
    loginState: session.signedIn ? 'logged-in' : 'logged-out',
    device: currentDevice(),
    trafficSource: trafficSource(),
  }
}
